
  var _styles = {
  "flight-theme-3": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "flight-theme-3_list": {
    "height": "6.05333rem",
    "width": "47%",
    "background": "#fff",
    "position": "relative",
    "marginRight": "4%",
    "marginBottom": "0.24rem",
    "marginRightt:nth-child(even)": 0,
    "marginBottomt:last-child": 0
  },
  "flight-theme-3_list_img": {
    "width": "100%",
    "height": "2.93333rem"
  },
  "flight-theme-3_list_label-word": {
    "borderBottomRightRadius": "0.10667rem",
    "fontSize": "0.29333rem",
    "fontFamily": "PingFangSC-Regular",
    "height": "0.45333rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.13333rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.13333rem",
    "position": "absolute",
    "top": 0,
    "left": 0
  },
  "flight-theme-3_list_label-img": {
    "height": "0.42667rem",
    "position": "absolute",
    "top": "0.06667rem",
    "left": "0.13333rem"
  },
  "flight-theme-3_list_purchaserCount": {
    "position": "absolute",
    "left": 0,
    "top": "2.54667rem",
    "width": "4.56rem",
    "height": "0.42667rem",
    "lineHeight": "0.42667rem",
    "paddingLeft": "0.13333rem",
    "background": "rgba(51,51,51,.7)",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.24rem",
    "color": "rgb(255,255,255)"
  },
  "flight-theme-3_list_flight-city": {
    "height": "0.44rem",
    "lineHeight": "0.44rem",
    "marginTop": "0.10667rem",
    "marginRight": "0.24rem",
    "marginBottom": "0.14667rem",
    "marginLeft": "0.26667rem",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(51,51,51)",
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap"
  },
  "flight-theme-3_list_flight-depart": {
    "height": "0.42667rem",
    "lineHeight": "0.42667rem",
    "marginTop": 0,
    "marginRight": "0.26667rem",
    "marginBottom": "0.04rem",
    "marginLeft": "0.26667rem",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "flight-theme-3_list_flight-depart_time": {
    "color": "rgb(153,153,153)",
    "fontSize": "0.29333rem",
    "fontFamily": "PingFangSC-Regular",
    "lineHeight": "0.42667rem"
  },
  "flight-theme-3_list_flight-depart_discount": {
    "float": "right",
    "lineHeight": "0.29333rem",
    "marginLeft": "0.13333rem",
    "paddingTop": "0.06667rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.06667rem",
    "paddingLeft": "0.16rem",
    "borderWidth": "1px",
    "borderStyle": "solid",
    "borderColor": "rgb(251,101,68)",
    "color": "rgb(251,101,68)",
    "fontSize": "0.29333rem",
    "fontFamily": "PingFangSC-Regular",
    "width": "fit-content"
  },
  "flight-theme-3_list_flight-depart_ticket": {
    "float": "right",
    "width": "0.88rem",
    "textAlign": "center",
    "paddingTop": "0.06667rem",
    "paddingRight": 0,
    "paddingBottom": "0.06667rem",
    "paddingLeft": 0,
    "lineHeight": "0.29333rem",
    "borderWidth": "2px",
    "borderStyle": "solid",
    "borderColor": "rgb(21,203,46)",
    "color": "rgb(21,203,46)"
  },
  "flight-theme-3_list_price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "height": "0.64rem",
    "lineHeight": "0.64rem",
    "marginLeft": "0.26667rem",
    "fontFamily": "Helvetica-Bold",
    "fontSize": "0.53333rem",
    "color": "rgb(251,101,68)"
  },
  "flight-theme-3_list_price_price-sym": {
    "marginRight": "0.06667rem",
    "fontSize": "0.26667rem"
  },
  "flight-theme-3_list_price_price-num": {
    "fontSize": "0.53333rem",
    "lineHeight": "0.64rem"
  },
  "flight-theme-3_list_btn": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "width": "100%",
    "height": "1.04rem",
    "lineHeight": "1.04rem",
    "textAlign": "center",
    "background": "#fb6544",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem"
  }
};



  module.exports = _styles;
  